"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_select_1 = require("react-select");
const utils_1 = require("../../utils");
const context_1 = require("./context");
const react_if_1 = require("react-if");
// import { ErrorIndicator } from './ErrorIndicator';
const buttons_1 = require("../../buttons");
const useOsmosysError_1 = require("../../../hooks/useOsmosysError");
exports.IndicatorsContainer = (_a) => {
    var _b;
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    const { showAsLoadingState, result, toggleLoadingBuffer, value, clearable, onChange, prettyResourceName, skip, multiple, disabled, } = context_1.useOsmosysSelectBoxContext();
    const errorMessage = useOsmosysError_1.useOsmosysError(result.error);
    const link = react_1.useMemo(() => {
        var _a;
        if (multiple) {
            return '';
        }
        if ((_a = value) === null || _a === void 0 ? void 0 : _a.resourceUrl) {
            return value.resourceUrl;
        }
        return '';
    }, [(_b = value) === null || _b === void 0 ? void 0 : _b.resourceUrl, multiple]);
    if (!result) {
        return (react_1.default.createElement(react_select_1.components.IndicatorsContainer, Object.assign({}, props), children));
    }
    return (react_1.default.createElement(react_select_1.components.IndicatorsContainer, Object.assign({}, props),
        react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "IndicatorsContainer", marginLeft: "sm", marginRight: "sm", flexRow: true, className: "h-100" },
            react_1.default.createElement(react_if_1.When, { condition: !!link },
                react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true },
                    react_1.default.createElement(buttons_1.OsmosysButton, { osysName: "OsmosysSelectBox.OpenOsmosysResource", osysIcon: "externalLink", tooltip: `Open ${prettyResourceName.noCase}`, osysStyle: "selectIndicator", href: link, openInNewTab: true }))),
            react_1.default.createElement(react_if_1.When, { condition: !!(clearable && value) },
                react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true },
                    react_1.default.createElement(buttons_1.OsmosysButton, { osysName: "OsmosysSelectBox.Clear", osysIcon: "erase", tooltip: `Clear ${prettyResourceName.noCase}`, osysStyle: "selectIndicator", onClick: () => {
                            onChange(multiple ? [] : null);
                        } }))),
            react_1.default.createElement(react_if_1.When, { condition: !!(result.error || errorMessage) },
                react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true },
                    react_1.default.createElement(buttons_1.OsmosysButton, { osysName: "OsmosysSelectBox.Error", osysIcon: "exclamation", tooltip: errorMessage, osysStyle: "selectIndicator" }))),
            react_1.default.createElement(react_if_1.When, { condition: !disabled },
                react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true },
                    react_1.default.createElement(buttons_1.OsmosysButton, { osysName: "OsmosysSelectBox.Refresh", osysIcon: showAsLoadingState ? 'spinner' : 'reload', iconSpin: showAsLoadingState, osysStyle: "selectIndicator", disabled: skip || showAsLoadingState, tooltip: skip
                            ? 'Loading is disabled. Does Osmosys have enough information to load this?'
                            : 'Refresh', onClick: () => {
                            if (!showAsLoadingState) {
                                toggleLoadingBuffer(true);
                                result.refetch();
                            }
                        } }))))));
};
//# sourceMappingURL=IndicatorsContainer.js.map